import { PhotoControl } from '@components/PhotoControl/PhotoControl'
import {
  Box,
  Button,
  Flex,
  Group,
  MultiSelect,
  Select,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core'
import classes from './PersonalInfo.module.css'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'

export const PersonalInfo = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Personal Info'))
  })

  return (
    <Flex p="md" gap={60} wrap="wrap">
      <Box>
        <Title order={4}>Profile</Title>
        <Stack mt="lg">
          <TextInput
            maw={450}
            size="md"
            label="First name"
            defaultValue="Alfredo"
            withAsterisk
          />
          <TextInput maw={450} size="md" label="Middle name" />
          <TextInput
            maw={450}
            size="md"
            label="Last Name"
            defaultValue="Carrillo"
            withAsterisk
          />
          <TextInput maw={450} size="md" label="Nickname" />
          <TextInput
            maw={450}
            size="md"
            label="Job Title"
            defaultValue="Director"
            withAsterisk
          />
          <Stack gap="xs">
            <Select
              maw={450}
              size="md"
              label="Preferred language"
              data={[
                {
                  label: 'Auto-detect',
                  value: 'AUTO_DETECT',
                },
                {
                  label: 'English',
                  value: 'ENGLISH',
                },
                {
                  label: 'Spanish',
                  value: 'SPANISH',
                },
              ]}
              value="AUTO_DETECT"
            />
            <Text size="sm" c="dimmed">
              Your detected language is English (United States).
            </Text>
          </Stack>
          <MultiSelect
            size="md"
            maw={450}
            label="Other languages"
            data={[
              {
                label: 'Italian',
                value: 'Italian',
              },
              {
                label: 'Mandarin',
                value: 'Mandarin',
              },
            ]}
            placeholder="Select one or more"
          />
          <Select
            size="md"
            maw={450}
            label="Gender"
            data={[
              {
                label: 'Male',
                value: 'MALE',
              },
              {
                label: 'Female',
                value: 'FEMALE',
              },
            ]}
            placeholder="Select"
          />
          <TextInput
            size="md"
            maw={450}
            label="Date of birth"
            placeholder="MM/DD/YYY"
          />
        </Stack>
      </Box>
      <Box style={{ flex: '1 1 auto' }}>
        <Title order={4}>Profile Picture</Title>
        <Box mt="lg">
          <PhotoControl />
        </Box>
        <Stack mt="lg">
          <Title order={4}>Contact Info</Title>
          <Stack gap="xs">
            <Text size="md">Email</Text>
            <Flex align="center" gap="xs" maw={450}>
              <TextInput
                size="md"
                defaultValue="alfredo@mybluecard.org"
                placeholder="name@example.com"
                style={{ flexGrow: 1, flexShrink: 1 }}
              />
              <Box className={classes.PersonalInfo__label} p="xs">
                <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                  Work
                </Text>
              </Box>
            </Flex>
            <Flex align="center" gap="xs" maw={450}>
              <TextInput
                size="md"
                placeholder="name@example.com"
                style={{ flexGrow: 1, flexShrink: 1 }}
              />
              <Box className={classes.PersonalInfo__label} p="xs">
                <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                  Personal
                </Text>
              </Box>
            </Flex>
          </Stack>
        </Stack>
        <Stack gap="xs" mt="lg">
          <Text size="md">Phone numbers</Text>
          <Flex align="center" gap="xs" maw={450}>
            <TextInput
              size="md"
              defaultValue="+1 (917) 555-1212"
              placeholder="+1 (212) 555-1212"
              style={{ flexGrow: 1, flexShrink: 1 }}
            />
            <Box className={classes.PersonalInfo__label} p="xs">
              <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                Mobile
              </Text>
            </Box>
          </Flex>
          <Flex align="center" gap="xs" maw={450}>
            <TextInput
              size="md"
              placeholder="+1 (212) 555-1212"
              style={{ flexGrow: 1, flexShrink: 1 }}
            />
            <Box className={classes.PersonalInfo__label} p="xs">
              <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                Direct
              </Text>
            </Box>
          </Flex>
          <Flex align="center" gap="xs" maw={450}>
            <TextInput
              size="md"
              placeholder="+1 (212) 555-1212"
              style={{ flexGrow: 1, flexShrink: 1 }}
            />
            <Box className={classes.PersonalInfo__label} p="xs">
              <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                Home
              </Text>
            </Box>
          </Flex>
          <Flex align="center" gap="xs" maw={450}>
            <TextInput
              size="md"
              placeholder="+1 (212) 555-1212"
              style={{ flexGrow: 1, flexShrink: 1 }}
            />
            <Box className={classes.PersonalInfo__label} p="xs">
              <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                Other
              </Text>
            </Box>
          </Flex>

          <Stack gap="xs" mt="lg">
            <Text size="md">Home address</Text>
            <TextInput maw={450} size="md" placeholder="Address line 1" />
            <TextInput maw={450} size="md" placeholder="Address line 2" />
            <TextInput maw={450} size="md" placeholder="City" />
            <Flex maw={450} gap="xs">
              <Select
                size="md"
                data={['Florida', 'New York']}
                placeholder="State"
              />
              <TextInput size="md" placeholder="Zipcode" />
            </Flex>
          </Stack>
        </Stack>
        <Flex maw={450} mt="lg" justify="flex-end" gap="xs">
          <Button size="md" variant="default">
            Discard Changes
          </Button>
          <Button size="md">Save</Button>
        </Flex>
      </Box>
    </Flex>
  )
}
